import 'babel-polyfill';
import './css/site.css';
import 'bootstrap';
const App = require('./src/app.vue.html');
import Vuetify from 'vuetify';
import VeeValidate from 'vee-validate';
import 'vuetify/dist/vuetify.min.css'
import Vue from 'vue';
//import IdleVue from 'idle-vue';
import router from './src/router';
import store from './src/store';
import filters from './src/filters';

filters.forEach(f => {
    Vue.filter(f.name, f.execute);
})

Vue.use(Vuetify, {
    theme: {
        primary: '#4CB8AB',
        accent: '#4CB8AB'
    }
});
Vue.use(VeeValidate, {
    classes: true,
    delay: 1000000000
});

/*Timeout stuff*/
var timeoutLogout: any;
var timeoutWarning: any;
var warningVal: number = 15 * 60 * 1000; /*milliseconds*/
var timeoutVal: number = 20 * 60 * 1000; /*milliseconds*/
//var warningVal: number = 3000; /*milliseconds - test*/

new Vue({
    el: '#app-root',
    router: router,
    store: store,
    render: h => h(App),
    created() {
        this.refreshTimeout(); /*start the timeout timer(s)*/
        document.addEventListener('beforeunload', this.logOut);
        document.addEventListener('click', this.refreshTimeout);
    },
    methods: {
        logOut() {
            this.$store.dispatch('logout');
            this.$router.push('/login');
        },
        applicationWarning() {
            clearTimeout(timeoutWarning);
            timeoutWarning = setTimeout(() => {
                if (this.$store.getters.isAuthenticated === true) {
                    this.$store.dispatch('addApplicationMessages', { class: 'warning', multiline: false, messages: ["You are about to be logged out due to inactivity..."] });/*warn the user*/
                }
            }, warningVal);
        },
        applicationTimeout() {
            clearTimeout(timeoutLogout);
            timeoutLogout = setTimeout(() => {
                if (this.$store.getters.isAuthenticated === true)
                    this.logOut(); /*Log the user out*/
            }, timeoutVal);
        },
        refreshTimeout() {
            this.applicationWarning();
            this.applicationTimeout();
        }

    }
});



// WEBPACK FOOTER //
// ./ClientApp/boot.ts